var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItem',_vm._b({},'FormItem',_vm.itemProp,false),[_c('Select',{attrs:{"value":_vm.selectVal,"filterable":"","multiple":"","allow-create":"","placeholder":"请输入，按回车添加"},on:{"input":_vm.inputHandler}},_vm._l((_vm.tagList),function(item){return _c('Option',{key:item,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }